import { Component, Inject, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { loadLogonsList } from "@serasa/core/modules/users/state/actions/user.actions";
import { CloneLogonResult } from "@serasa/core/modules/users/interfaces/clone-logon.interface";

interface UserAddSuccessModalData {
  results?: CloneLogonResult[];
}

@Component({
  selector: "pl-user-add-success-modal",
  templateUrl: "./user-add-success-modal.component.html",
  styleUrls: ["./user-add-success-modal.component.scss"],
  standalone: false,
})
export class UserAddSuccessModalComponent {
  public readonly results: CloneLogonResult[];

  constructor(
    private readonly store: Store,
    private readonly dialogRef: MatDialogRef<UserAddSuccessModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data: UserAddSuccessModalData | null,
  ) {
    this.results = data?.results ?? [];
  }

  public closeModal(): void {
    this.dialogRef.close();
    this._refreshUserList();
  }

  private _refreshUserList(): void {
    const strgMatPaginator: { offset: number; limit: number } = JSON.parse(
      localStorage.getItem("mat-paginator") || "{}",
    );
    this.store.dispatch(
      loadLogonsList({
        offset: strgMatPaginator.offset || 0,
        limit: 20,
        isPagination: false,
      }),
    );
  }
}
